//@flow

import React, { Component } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  Dimensions,
  ScrollView,
} from "react-native";
import { connect } from "react-redux";
import {
  changeSignupProgress,
  addSignupChoice,
  removeSignupChoice,
} from "@microdoing/shared/services/signup/actions";
import SignupHeader from "./SignupHeader";
import SignupBottom from "./SignupBottom";
import { getUserId } from "@microdoing/shared/services/user/selectors";
import i18n from "@microdoing/shared/i18n";
import { widthPercentageToDP as wp } from "react-native-responsive-screen";
import { getIsConnected } from "@microdoing/shared/services/network/selectors";
import theme from "app/Theme/Theme";
import { SafeAreaView } from "react-native-safe-area-context";

const { width, height } = Dimensions.get("window");
const aspectRatio = height / width;
const isPad = () => aspectRatio < 1.6;

class PreferenceSignup extends Component {
  goNext = async () => {
    this.props.navigation.navigate("SignupTopics");
  };

  goBack = () => {
    this.props.navigation.goBack();
    this.props.changeSignupProgress(-this.props.progressRatio);
  };

  onPressRemove = choice => () => {
    this.props.removeSignupChoice(choice);
  };

  onPressChoice = choice => () => {
    this.props.addSignupChoice(choice);
  };

  renderRows = titles => {
    return titles.map((el, i) => {
      return (
        <TouchableOpacity
          key={i}
          onPress={
            this.props.choice.findIndex(choice => choice.value === el.value) >
            -1
              ? this.onPressRemove(el)
              : this.onPressChoice(el)
          }
          style={
            this.props.choice.findIndex(choice => choice.value === el.value) >
            -1
              ? styles.row
              : { ...styles.row, backgroundColor: theme.colors["neutral.400"] }
          }
        >
          <Text style={styles.rankingText}>
            {this.props.choice.findIndex(choice => choice.value === el.value) +
              1}
          </Text>
          <View style={styles.description}>
            <Text style={styles.rowText}>{el.name}</Text>
            <Text style={styles.descriptionText}>{el.description}</Text>
          </View>
        </TouchableOpacity>
      );
    });
  };

  isSelected = value => () => {
    return this.props.choice.findIndex(el => el.value === value) > -1;
  };

  render() {
    return (
      <View style={styles.mainViewStyle}>
        <SafeAreaView style={{ flex: 1 }}>
          <View style={styles.topViewStyle}>
            <SignupHeader
              progress={this.props.progress}
              title={i18n.t("signup-header")}
            />
          </View>
          <ScrollView
            showsVerticalScrollIndicator
            keyboardShouldPersistTaps="always"
            contentContainerStyle={styles.scrollView}
          >
            <Text style={styles.mainTextStyle}>
              {i18n.t("signup-preference-title-first")}{" "}
              <Text style={{ fontWeight: "bold" }}>
                {i18n.t("signup-preference-title-second")}
              </Text>
            </Text>
            {this.renderRows(this.props.choiceAvailable)}
          </ScrollView>
          <View style={styles.bottomViewStyle}>
            <SignupBottom
              isRequesting={this.props.requesting}
              isRightButtonLocked={this.props.choice.length < 1}
              onPressBack={this.goBack}
              onPressNext={this.goNext}
            />
          </View>
        </SafeAreaView>
      </View>
    );
  }
}

const styles = {
  mainViewStyle: {
    flex: 1,
    backgroundColor: "white",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  scrollView: {
    backgroundColor: "white",
    justifyContent: "center",
    alignItems: "center",
  },
  lastOne: {
    color: theme.colors["neutral.400"],
    fontStyle: "italic",
    fontSize: height < 600 || isPad() ? 10 : 14,
    marginLeft: 5,
    marginRight: 5,
    marginTop: isPad() ? 10 : 20,
  },
  topViewStyle: {
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    marginBottom: 15,
  },
  bottomViewStyle: {
    marginBottom: isPad() ? 5 : height < 600 ? 5 : 20,
    width,
    height: 50,
    backgroundColor: "red",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  mainTextStyle: {
    textAlign: "center",
    marginBottom: 20,
    width: wp("90%"),
    fontSize: wp("5%"),
    fontWeight: "normal",
    color: "#4a4a4a",
  },
  rowText: {
    marginTop: 5,
    fontSize: wp("4.5%"),
    color: "white",
    fontWeight: "bold",
  },
  rankingText: {
    fontSize: wp("4.5%"),
    marginLeft: 15,
    marginRight: 15,
    color: "white",
    fontWeight: "bold",
  },
  row: {
    marginBottom: 10,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.colors["brand.500"],
    width: width - 20,
    borderRadius: 8,
  },
  description: {
    flex: 1,
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column",
  },
  descriptionText: {
    marginTop: 5,
    marginBottom: 10,
    color: theme.colors["neutral.white"],
    fontSize: wp("3.8%"),
  },
};

const mapStateToProps = state => {
  const {
    stats,
    progress,
    progressRatio,
    choice,
    choiceAvailable,
    firstName,
    lastName,
    birthDate,
    sex,
    manager,
    requesting,
    jobFunction,
  } = state.signup;
  return {
    isConnected: getIsConnected(state),
    progress,
    choice,
    progressRatio,
    choiceAvailable,
    stats,
    jobFunction,
    firstName,
    lastName,
    birthDate,
    sex,
    manager,
    requesting,
    picture: state.user.picture,
    feelingEvolution: state.user.feelingEvolution,
    userId: getUserId(state),
  };
};

export default connect(mapStateToProps, {
  changeSignupProgress,
  addSignupChoice,
  removeSignupChoice,
})(PreferenceSignup);
